import { useRef } from "react";
import { useS3Upload } from "next-s3-upload";
import posthog from "posthog-js";

export default function UploadButton({ setURL, onUploadStart, onUploadDone }) {
  const ref = useRef(null);
  const { uploadToS3 } = useS3Upload();

  async function handleChange(e) {
    const file = e.target.files[0];
    if (file.size > 1024 * 1024 * 36) {
      alert("File shouldn't be larger than 36Mb");
    }
    if (onUploadStart) onUploadStart();
    posthog.capture("ModelUploaded", { url });

    const { url } = await uploadToS3(file);
    if (onUploadDone) onUploadDone(url);
    if (setURL) setURL(url);
  }
  return (
    <div
      style={{
        margin: "1.5em 1em",
        fontSize: 14,
        background: "#374151",
        borderRadius: "3px",
        padding: "1em 1em",
        cursor: "pointer",
        textAlign: "center"
      }}
      onClick={() => {
        ref.current.click();
      }}
    >
      <input
        ref={ref}
        style={{ display: "none" }}
        onChange={handleChange}
        accept=".glb,.gltf"
        type="file"
      ></input>
      <span>
       ↑ Upload .GLTF or .GLB file
      </span>
    </div>
  );
}
